import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export type PrimaryNavContainerProps = {
    desktopHeight: number
    mobileHeight: number
}
// theme.uxfabric.components.appBar.navBar.default.borderColor !== "" &&
export const Container = styled("div")<PrimaryNavContainerProps>`
    display: flex;
    justify-content: center;
    background: ${({theme}) => theme.uxfabric.components.appBar.navBar.default.backgroundColor};
    width: 100%;
    height: ${props => props.mobileHeight}rem;
    @media (min-width: ${breakpoints.values.md}px) {
        height: ${props => props.desktopHeight}rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        background: ${({theme}) => theme.uxfabric.components.appBar.navBar.default.backgroundColor};
    }

    // This logic is present to pickout the opacity from the token and remove the border if set to 0
    // Added as having a 0 opacity border under the primary nav causes a gap between the active
    // indicator and the secondary nav tray
    border-bottom: ${({theme}) =>
        theme.uxfabric.components.appBar.navBar.default.borderColor.split(", ")[3].replace(")", "") !== "0"
            ? `0.0625rem solid ${theme.uxfabric.components.appBar.navBar.default.borderColor}`
            : "none"};
`

export const SnailTrailWrapper = styled("div")<PrimaryNavContainerProps>`
    z-index: 1;
    max-width: ${breakpoints.values.xl}px;
    padding: 0;
    width: 100%;

    @media (min-width: ${breakpoints.values.lg}px) {
        background: inherit;
    }
`
